import React from "react";

import {
  Box,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";


import BZLogo from "../../components/BZLogo";


export default function SmallScreenNotAllow({ navigation }) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [loading, setLoading] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1023px)");


  React.useEffect(() => {
  }, []);

  return (
    <Box loading={loading} className={"w-full h-full flex flex-col justify-center items-center"}>
      <BZLogo className={"!my-0 !flex text-center"} />
      <div
        className={
          "container py-4 sm:py-0 mx-auto grid place-items-center bg-white"
        }
      >
        <div className={"grid grid-flow-row gap-2 mb-10 text-center place-items-center"}>
          <h1
            className={
              "my-4 font-extrabold text-2xl text-center text-brown-coffee"
            }
          >
            Mobile site comming soon.
          </h1>
          <p className={"text-brown-coffee text-lg"}>
            Our application is currently not optimised to work on Mobile screens. Please open this link via your laptop or desktop browser.
          </p>
          <svg fill="#481b3a" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100px" height="100px" viewBox="0 0 217.267 217.267" xmlSpace="preserve" stroke="#481b3a"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M108.633,0C48.73,0,0,48.73,0,108.633c0,29.931,12.171,57.071,31.816,76.738c0.014,0.014,0.017,0.034,0.031,0.048 s0.032,0.018,0.05,0.031c19.665,19.646,46.807,31.815,76.736,31.815c59.901,0,108.634-48.731,108.634-108.633 C217.267,48.73,168.534,0,108.633,0z M108.633,7.009c26.762,0,51.12,10.416,69.285,27.379L155.941,56.37v-3.806 c0-9.661-7.861-17.521-17.521-17.521H78.847c-9.661,0-17.521,7.86-17.521,17.521v98.421l-26.938,26.939 c-16.964-18.172-27.379-42.534-27.379-69.292C7.009,52.599,52.599,7.009,108.633,7.009z M68.334,153.888l68.333-68.334v57.975 c0,1.938,1.567,3.505,3.505,3.505c1.937,0,3.504-1.567,3.504-3.505V78.545l5.257-5.256v91.413c0,5.798-4.716,10.513-10.513,10.513 H78.847c-5.795,0-10.513-4.715-10.513-10.513V153.888z M143.676,68.635v-7.875c0-1.937-1.567-3.504-3.504-3.504 c-1.938,0-3.505,1.567-3.505,3.504v14.883l-68.333,68.333V52.564c0-5.797,4.717-10.513,10.513-10.513h59.573 c5.797,0,10.513,4.716,10.513,10.513v10.814L143.676,68.635z M108.633,210.257c-26.759,0-51.12-10.417-69.287-27.377l21.979-21.98 v3.806c0,9.66,7.861,17.521,17.521,17.521h59.573c9.66,0,17.521-7.861,17.521-17.521V66.281l26.938-26.938 c16.961,18.17,27.378,42.53,27.378,69.29C210.258,164.667,164.667,210.257,108.633,210.257z"></path> <path d="M120.46,47.308H96.806c-1.939,0-3.504,1.565-3.504,3.504c0,1.937,1.565,3.504,3.504,3.504h23.654 c1.938,0,3.504-1.567,3.504-3.504C123.964,48.874,122.397,47.308,120.46,47.308z"></path> <path d="M108.619,171.385c7.146,0,12.956-5.814,12.956-12.963c0-7.149-5.811-12.963-12.956-12.963 c-7.148,0-12.963,5.813-12.963,12.963C95.656,165.571,101.471,171.385,108.619,171.385z M108.619,152.468 c3.284,0,5.948,2.672,5.948,5.954s-2.668,5.954-5.948,5.954c-3.28,0-5.954-2.672-5.954-5.954S105.339,152.468,108.619,152.468z"></path> </g> </g> </g></svg>
        </div>
      </div>
    </Box>
  );
}
